<template>
  <div
    class="flex flex-col items-center justify-center"
    :class="
      variant === 'modal'
        ? 'h-[646px] pt-[11px]'
        : checker.emptySource.value === 'visual'
          ? 'flex-1 pb-[85px]'
          : 'flex-1 pb-[105px]'
    "
  >
    <div class="flex w-[260px] flex-col items-center">
      <component
        :is="copy.icon"
        class="size-[34px] text-gray-800"
        aria-hidden="true"
      />
      <p
        class="mt-6 text-center text-[20px] leading-5 font-medium tracking-[-0.25px] text-gray-800"
      >
        No matches found
      </p>
      <p
        class="mt-4 text-center text-[14px] leading-5 text-gray-600"
        :style="{ width: `${copy.width}px` }"
      >
        {{ copy.message }}
      </p>
      <Button
        variant="stroke"
        :size="variant === 'modal' ? 'md' : 'lg'"
        class="mt-[33px]"
        :class="variant === 'sheet' && 'h-10!'"
        @click="checker.backToCapture"
      >
        {{ copy.action }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Button } from '@dacr/library'
import {
  EyeOpenIcon,
  FileSearchIcon,
  VocalAndInstrumentalIcon,
} from '@dacr/icons'

import { useChecker } from './useChecker'

defineProps<{ variant: 'modal' | 'sheet' }>()

const checker = useChecker()

const COPY = {
  audio: {
    icon: VocalAndInstrumentalIcon,
    message: 'We couldn’t match this audio to your Dacr registrations',
    width: 190,
    action: 'Listen again',
  },
  visual: {
    icon: EyeOpenIcon,
    message: 'We couldn’t match this visual capture to your Dacr registrations',
    width: 220,
    action: 'Capture again',
  },
  file: {
    icon: FileSearchIcon,
    message: 'We couldn’t match this file to your Dacr registrations',
    width: 220,
    action: 'Upload another',
  },
} as const

const copy = computed(() => COPY[checker.emptySource.value])
</script>
